import { render } from "./CreateEmployeeGatepass.vue?vue&type=template&id=b07d9748&scoped=true"
import script from "./CreateEmployeeGatepass.vue?vue&type=script&lang=js"
export * from "./CreateEmployeeGatepass.vue?vue&type=script&lang=js"

import "./CreateEmployeeGatepass.vue?vue&type=style&index=0&id=b07d9748&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b07d9748"]])

export default __exports__